import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {catchError, map, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';

import * as AuthActions from '../actions/auth.actions';
import {AuthService} from '../../services/auth-service';
import {Store} from '@ngrx/store';
import {AuthSelectors} from '../selectors';
import {AUTH_CODE, AUTH_TOKEN} from '../../consts';
import {Router} from '@angular/router';
import {Base64Decode} from '../../../../core/utils/base64-decode';


@Injectable()
export class AuthEffects {

  login$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.login),
      switchMap((action) => {
        return this.authService.login(action.username, action.password).pipe(
          switchMap((result: any) => {
            this.store.dispatch(AuthActions.setToken({token: result?.access_token}));
            return of(AuthActions.loginByToken({url: '/admin'}));
          }),
          catchError((error) => of(AuthActions.authError({error})))
        );
      })
    );
  });

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.logout),
      switchMap((action) => {
        localStorage.removeItem(AUTH_TOKEN);
        localStorage.removeItem(AUTH_CODE);
        this.store.dispatch(AuthActions.setToken({token: ''}));
        return of(AuthActions.logoutSuccess());
      })
    );
  });

  logoutSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.logoutSuccess),
      tap(async (action) => {
        await this.router.navigate(['/auth/login']);
      })
    );
  }, {dispatch: false});

  loginByToken$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.loginByToken),
      switchMap((action) => {
        const rawUserInfo = localStorage.getItem(AUTH_TOKEN)?.split('.')[1] || '';
        const user_type = Base64Decode.b64ToObject(rawUserInfo)?.user_type;
        // const user_type = JSON.parse(atob(localStorage.getItem(AUTH_TOKEN)?.split('.')[1] || ''))?.user_type;
        return this.authService.getCurrentUser(user_type).pipe(
          map((result: any) => {
            return AuthActions.loginSuccess({user: result, url: action.url, queryParams: action.queryParams});
          }),
          catchError((error) => of(AuthActions.logoutSuccess()))
        );
      })
    );
  });

  loginByAuthCode$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.loginByAuthCode),
      switchMap((action) => {
        return this.authService.loginByAuthCode(action.auth_code).pipe(
          map((result: any) => {
            this.store.dispatch(AuthActions.setToken({token: result?.token}));
            if (!result?.token) {
              return AuthActions.authError({error: 'User not found'});
            }
            return AuthActions.loginSuccess({user: result, url: ''});
          }),
          catchError((error) => of(AuthActions.logout()))
        );
      })
    );
  });

  authError$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.authError),
      tap(async (action) => {
        localStorage.removeItem(AUTH_CODE);
        await this.router.navigate(['/auth/login']);
      })
    );
  }, {dispatch: false});

  loginSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.loginSuccess),
      withLatestFrom(this.store.select(AuthSelectors.selectAuthState)),
      tap(async ([action, state]) => {

        const url = action.url?.split('?')[0] ?? action.url;

        // console.log(state.user?.status)
        if (state.user?.status && state.user?.status !== 'ACTIVE' && state.user?.status !== 'BOOSTED') {
          await this.router.navigate(['/lumii-not-available/1']);
          return;
        }



        if (state.user?.userType === 'CHILD') {
          await this.router.navigate(['/chat']);
        } else {
          await this.router.navigate([url], {queryParams: action.queryParams});
        }

       // console.log(action.url)

        //
        // switch (state?.user?.status) {
        //
        //   case USER_STATUS.APPLICATION:
        //     await this.router.navigate(['/app/questionary']);
        //     break;
        //   case USER_STATUS.SETUP_RATES:
        //     await this.router.navigate(['/app/setup-rates']);
        //     break;
        //   case USER_STATUS.WAITING_FOR_APPROVE:
        //     await this.router.navigate(['/app/approval']);
        //     break;
        //
        //   // case USER_STATUS.FILLING_PROFILE:
        //   //   await this.router.navigate(['/app/registration']);
        //   //   break;
        //
        //   //TODO depends on user type
        //   case USER_STATUS.ACTIVE:
        //
        //     if (action.url.includes('/app/') || action.url.includes('/call/')) {
        //       const params = action.url.split('?')[1];
        //       if (params?.length > 0) {
        //         const queryParams = params.split('&')
        //           .map(p => p.split('='))
        //           .reduce((obj, pair) => {
        //             const [key, value] = pair.map(decodeURIComponent);
        //             obj[key] = value;
        //             return obj;
        //           }, {} as any);
        //
        //         await this.router.navigate([action.url.split('?')[0]], {queryParams});
        //       } else {
        //         await this.router.navigate([action.url]);
        //       }
        //
        //     } else {
        //       const rawUserInfo = localStorage.getItem(AUTH_TOKEN)?.split('.')[1] || '';
        //       const user_type = Base64Decode.b64ToObject(rawUserInfo)?.user_type;
        //       // const user_type = JSON.parse(atob(localStorage.getItem(AUTH_TOKEN)?.split('.')[1] || ''))?.user_type;
        //
        //     }
        //
        //     break;
        //
        //   default:
        //   //console.log('navigate to main page');
        // }
      })
    );
  }, {dispatch: false});


  constructor(private actions$: Actions,
              private authService: AuthService,
              private store: Store,
              private router: Router) {
  }

}
